import React, { useMemo } from 'react';
import { useAppContext } from '../../Services/AppContext';
import { UserAvatarImageType } from '../../Enums/UserAvatarImageType.enum';

interface Props {
	userId: string;
	createdAt?: string | Date;
	isDoctor?: boolean;
	type?: UserAvatarImageType;
	customClass?: string;
	profileImageUrl?: string | null;
}

const UserAvatarImage: React.FC<Props> = ({
	userId,
	createdAt,
	isDoctor,
	type = UserAvatarImageType.IMAGE,
	customClass,
	profileImageUrl,
}) => {
	const { socketUrl } = useAppContext();

	const imageLink = useMemo(() => {
		if (profileImageUrl) {
			return profileImageUrl;
		}

		let link = '/dist/placeholder/user-placeholder.png';

		if (createdAt) {
			const timeStamp = Math.floor(new Date(createdAt).getTime() / 1000);
			link =
				socketUrl +
				(isDoctor
					? '/doctors/' + userId + '/currentPicture'
					: '/patients/' + userId + '/profile');
			link += '?timestamp=' + timeStamp;
		}

		return link;
	}, [createdAt, isDoctor, userId]);

	return type === UserAvatarImageType.IMAGE ? (
		<img src={imageLink} alt={'avatar'} className={customClass} />
	) : (
		<div
			className={customClass}
			style={{ backgroundImage: `url("` + imageLink + `")` }}
		/>
	);
};

export default UserAvatarImage;
